import { LoginStore } from "@modules/authentication/pages/login/login.store";
import { UserProfile } from "@modules/main/pages/user-profile/user-profile.model";
import { UserProfileStore } from "@modules/main/pages/user-profile/user-profile.store";
import { useService, useStore } from "@policoders/di";
import { BreadcrumbService } from "@policoders/ds";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface IDashboardItemProps {
  label: string;
  route: string;
  withAccess: boolean;
}

export const DashboardItem = ({ label, route, withAccess }: IDashboardItemProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(route);
  };

  return (
    <>
      {withAccess && (
        <div className="col-md-6 col-xlg-4">
          <div className="bg-secondary text-light p-5 rounded" role="button" onClick={handleClick}>
            <h1 className="display-5">{label}</h1>
            <hr />
          </div>
        </div>
      )}
    </>
  );
};

const HomePage: React.FC = () => {
  const loginState = useStore<LoginStore>("LoginStore").state;
  const userProfileStore = useService<UserProfileStore>("UserProfileStore");
  const [userProfile, setUserProfile] = useState<UserProfile>(new UserProfile());

  useEffect(() => {
    const email = loginState.user?.email;
    if (!email) return;
    userProfileStore.load(email).subscribe(value => {
      setUserProfile(value);
    });
  }, [loginState.user?.email, userProfileStore]);

  const breadcrumb = useService<BreadcrumbService>("BreadcrumbService");
  useEffect(() => {
    breadcrumb.set([{ label: "Início", value: "/" }]);
  }, [breadcrumb]);

  return (
    <div className="row gy-3">
      <DashboardItem
        label="Administração"
        route="/administration"
        withAccess={!!userProfile.modules.administration}
      />
      <DashboardItem
        label="Restaurante"
        withAccess={!!userProfile.modules.chefs_assistant}
        route="/chefs-assistant"
      />
      <DashboardItem
        label="Changeman"
        withAccess={!!userProfile.modules.changeman}
        route="/changeman"
      />
      <DashboardItem
        label="Clínica"
        withAccess={!!userProfile.modules.health}
        route="/health/patients"
      />
      <DashboardItem
        label="HelpDesk"
        withAccess={!!userProfile.modules.helpdesk}
        route="/helpdesk"
      />
      <DashboardItem
        label="Overview"
        withAccess={!!userProfile.modules.overview}
        route="/overview"
      />
    </div>
  );
};

export default HomePage;
